"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { pickBiomeFromSeed } from "./world/biomes";

export default function TerrainMeta() {
    const t = useTranslations("terrain");
    const [seed, setSeed] = useState<number | null>(null);
    const [inNether, setInNether] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        const read = () => {
            const m = window.location.hash.match(/seed=(\d+)/);
            setSeed(m ? Number(m[1]) : null);
            setInNether(window.location.hash.includes("dim=nether"));
        };
        read();
        window.addEventListener("hashchange", read);
        return () => window.removeEventListener("hashchange", read);
    }, []);

    const regen = () => {
        const next = Math.floor(Math.random() * 100_000_000);
        const url = new URL(window.location.href);
        url.hash = `seed=${next}`;
        window.history.replaceState(null, "", url.toString());
        window.dispatchEvent(new HashChangeEvent("hashchange"));
    };

    const copySeed = async () => {
        if (seed == null) return;
        try {
            await navigator.clipboard.writeText(String(seed));
            setCopied(true);
            setTimeout(() => setCopied(false), 1200);
        } catch {
            // clipboard unavailable; ignore
        }
    };

    if (seed == null) {
        return (
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                seed –
            </p>
        );
    }

    const biome = inNether ? "nether" : pickBiomeFromSeed(seed).replace("_", " ");

    return (
        <div className="flex w-full flex-col gap-1 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
            <div className="flex items-center justify-between gap-2">
                <button
                    type="button"
                    onClick={copySeed}
                    className="inline-flex min-w-0 items-center gap-1 rounded text-muted-foreground transition-colors hover:text-foreground"
                    aria-label={t("copySeedAria", { seed })}
                    title={t("copySeed")}
                >
                    <span className="truncate">seed #{seed}</span>
                    <span aria-hidden className="opacity-60">
                        {copied ? "✓" : "⧉"}
                    </span>
                </button>
                <button
                    type="button"
                    onClick={regen}
                    className="shrink-0 text-muted-foreground transition-colors hover:text-foreground"
                    aria-label={t("regenerateAria")}
                >
                    ↻ {t("regenShort")}
                </button>
            </div>
            <span className="truncate">{biome}</span>
        </div>
    );
}
